/**
 * Other
 */

// 商品詳細の店長コメント
export function manager_comment() {
  document.addEventListener("DOMContentLoaded", function() {
    // 'c-manager-comment'クラスを持つ要素をすべて取得
    var comments = document.querySelectorAll('.c-manager-comment');

    // 各要素に対してループ処理
    comments.forEach(function(comment) {
      // 'body'クラスを持つ子要素を取得
      var body = comment.querySelector('.c-manager-comment__inner');

      // bodyの中身が空かどうかチェック
      if (!body.innerHTML.trim()) {
        // 中身が空の場合、要素を非表示に設定
        comment.style.display = 'none';
      }
    });
  });
}
